/**
 * BackButton.tsx
 *
 * Styled back / cancel link extracted from example/mvp/login.html
 * (.login__back / .signup__back).  Uses the .auth-back CSS class.
 *
 * Usage:
 *   <BackButton onClick={handleBack}>Use a different email or phone</BackButton>
 */

import React from "react";

interface BackButtonProps {
  onClick?: () => void;
  children: React.ReactNode;
  className?: string;
}

function ChevronLeft() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M15 6 L9 12 L15 18" />
    </svg>
  );
}

export function BackButton({ onClick, children, className }: BackButtonProps) {
  return (
    <button
      type="button"
      className={["auth-back", className].filter(Boolean).join(" ")}
      onClick={onClick}
    >
      <ChevronLeft />
      {children}
    </button>
  );
}

export default BackButton;
